import type { UseCompanyListProps, UseCompanyListResult } from "@/types/types"
import { useMemo } from "react"

export const useCompanyList = ({ companies = [], componentId }: UseCompanyListProps): UseCompanyListResult => {
  const validCompanies = useMemo(() => {
    return companies.filter(company => company.image && company.image.trim())
  }, [companies])
  const hasValidCompanies = validCompanies.length > 0

  const swiperConfig = useMemo(() => {
    const shouldLoop = validCompanies.length > 2

    return {
      loop: shouldLoop,
      pagination: {
        clickable: true,
      },
    }
  }, [validCompanies.length])

  const id = useMemo(() => componentId || `company-list-${Math.random().toString(36).substr(2, 9)}`, [componentId])

  return {
    validCompanies,
    hasValidCompanies,
    swiperConfig,
    id,
  }
}
